import { Directive, EventEmitter, Input, Optional, Output } from "@angular/core";
import { MatSelect } from "@angular/material/select";

@Directive({
    selector: "[msInfiniteScroll]",
    standalone: false
})
export class MatSelectInfiniteScrollDirective {
	@Input() complete = false;
	@Input() threshold = 100;
	@Output() infiniteScroll = new EventEmitter<void>();

	private scrollListener?: (event: Event) => void;

	constructor(@Optional() private matSelect: MatSelect) {
		this.matSelect?.openedChange.subscribe((opened) => {
			if (opened) {
				this.attachScrollListener();
			} else {
				this.detachScrollListener();
			}
		});
	}

	private attachScrollListener() {
		const panel = this.matSelect?.panel?.nativeElement as HTMLElement;
		if (!panel) {
			return;
		}
		this.scrollListener = () => this.onPanelScroll(panel);
		panel.addEventListener("scroll", this.scrollListener);
	}

	private detachScrollListener() {
		const panel = this.matSelect?.panel?.nativeElement as HTMLElement;
		if (panel && this.scrollListener) {
			panel.removeEventListener("scroll", this.scrollListener);
		}
		this.scrollListener = undefined;
	}

	private onPanelScroll(panel: HTMLElement) {
		if (this.complete) {
			return;
		}
		const atBottom =
			panel.scrollTop + panel.clientHeight >= panel.scrollHeight - this.threshold;
		if (atBottom) {
			this.infiniteScroll.emit();
		}
	}
}
